module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-slide-filelist"
  }, [_c('rt-section', {
    attrs: {
      "title": _vm.title,
      "icon": "rt-base-account"
    }
  }, [_c('el-upload', {
    staticClass: "addBtn",
    attrs: {
      "slot": "btn",
      "show-file-list": false,
      "http-request": _vm.uploadFile,
      "action": ""
    },
    slot: "btn"
  }, [_c('rt-icon', {
    attrs: {
      "color": _vm.iconColor,
      "name": "rt-base-plus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "file-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "file-icon"
    }, [(['jpg', 'png', 'jpeg'].indexOf(_vm.fileSuffix(item.name)) > -1) ? _c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }) : _c('rt-icon', {
      attrs: {
        "name": _vm.fileIconName(item.name),
        "color": _vm.fileIconColor(item.name),
        "size": "28"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "file-detail"
    }, [_c('p', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "uploadTime-and-operation"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.uploadTime))]), _vm._v(" "), _c('div', {
      staticClass: "operation"
    }, [(
      ['jpg', 'png', 'jpeg'].indexOf(_vm.fileSuffix(item.name)) > -1
    ) ? _c('rt-button', {
      attrs: {
        "text": "",
        "type": "plain"
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item.url)
        }
      }
    }, [_vm._v("预览")]) : _vm._e(), _vm._v(" "), _c('rt-popconfirm', {
      attrs: {
        "title": "确定需要删除这条内容吗？"
      },
      on: {
        "onConfirm": function($event) {
          return _vm.onConfirm(item.name, index)
        }
      }
    }, [_c('rt-button', {
      attrs: {
        "slot": "reference",
        "text": "",
        "type": "plain"
      },
      slot: "reference"
    }, [_vm._v("删除")])], 1)], 1)])])])
  }), 0)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.imgVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.imgVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10281268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadSlideFilelist/rtUploadSlideFile.vue
// module id = 1464
// module chunks = 124